// extracted by mini-css-extract-plugin
export var columnsComponent = "index-v2-module--columnsComponent--4074a";
export var columnsComponentColumn = "index-v2-module--columnsComponentColumn--c0092";
export var columnsComponentColumnHeader = "index-v2-module--columnsComponentColumnHeader--91248";
export var columnsComponentColumnIndex = "index-v2-module--columnsComponentColumnIndex--d4a45";
export var columnsComponentColumns = "index-v2-module--columnsComponentColumns--542d7";
export var columnsComponentDescription = "index-v2-module--columnsComponentDescription--3910b";
export var columnsComponentHeader = "index-v2-module--columnsComponentHeader--251e8";
export var columnsComponentHeading = "index-v2-module--columnsComponentHeading--a6952";
export var hasTextWeightBold = "index-v2-module--has-text-weight-bold--670fc";
export var hasTextWeightLight = "index-v2-module--has-text-weight-light--204e0";
export var isUppercase = "index-v2-module--is-uppercase--ebbb3";